import React from 'react'
import { Link } from 'react-router-dom'
import {
  FacebookIcon,
  InstagramIcon,
  LinkedinIcon,
  TwitterIcon2,
  TiktokIcon,
  YoutubeIcon,
} from 'components/Icons'
import { useMediaQuery } from 'react-responsive'

function Footer() {
  const logo =
    'https://remote-recruit-email-temp.s3.us-east-1.amazonaws.com/website_images/SquarewhiteRR300.webp'

  return (
    <div className="relative bottom-0 w-full pt-[30px] lg:pt-[60px] pb-[42px] mt-15 bg-[#00113C] flex flex-col justify-center items-center">
      {/* <div className="w-full h-[153px] mb-[141px]">
        <p className="text-white text-center font-sans not-italic text-[40px] font-normal">
          Let's Connect and Make It Happen!
        </p>
        <p className="text-white text-center font-sans text-sm not-italic font-normal opacity-80 self-stretch">
          Have questions or need support? Reach out, and we’ll help you bridge
          the gap between talent and <br /> opportunity.
        </p>
        <div className="flex justify-center items-end">
          <a href="mailto:team@remoterecruit.com">
            <button className="w-[125px] h-[34px] bg-[#F7F9FB] mt-[15px] color-[#00113C] px-[5px] py-[6px] rounded-[4px] shrink-0">
              👋 Contact Us
            </button>
          </a>
        </div>
      </div> */}

      <div className="w-full max-w-[1220px] px-10 lg:px-0">
        <div className="flex flex-col lg:flex-row items-center justify-between">
          <div className="w-full lg:w-1/4 text-center lg:text-left">
            <Link
              aria-label="home page link"
              href="/"
              className="mx-auto lg:mx-0 flex w-[124px] h-[50px] items-center gap-2 mb-[36px] relative left-0 lg:left-[-20px]"
            >
              <img src={logo} alt="RemoteRecruit" loading="lazy" />
            </Link>
            <p className="text-white font-sans text-sm not-italic leading-[20px] font-normal mb-0 text-center lg:text-left">
              RemoteRecruit.com connects global jobseekers and employers through
              a seamless feel free platform with video resumes and AI Driven
              Matching
            </p>
            {/* <div>
              <a
                href="tel:+15077075970"
                className="text-white font-sans text-sm not-italic leading-[20px] font-normal mb-2 inline-flex items-center gap-2"
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M6.62 10.79a15.46 15.46 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1-.24c1.12.37 2.32.57 3.59.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C10.07 21 3 13.93 3 5a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.27.2 2.47.57 3.59a1 1 0 0 1-.24 1l-2.2 2.2Z"
                    fill="white"
                  />
                </svg>
                +1 507 707 5970
              </a>
            </div>
            <div>
              <a
                href="mailto:team@remoterecruit.com"
                className="text-white font-sans text-sm not-italic leading-[20px] font-normal mb-2 inline-flex items-center gap-2"
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M4 6h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1Z"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="m3 7 9 7 9-7"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                team@remoterecruit.com
              </a>
            </div> */}
          </div>
          <div className="w-full lg:w-3/4 flex lg:justify-end mt-6 lg:mt-0">
            <div className="flex gap-x-10 lg:gap-x-20 justify-around lg:justify-end w-full">
              <div>
                <p className="text-white font-sans text-base not-italic leading-[20px] font-bold mb-5">
                  Quick Links
                </p>
                <ul>
                  <li>
                    <a
                      href="https://remoterecruit.com/remote-jobs/about/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white font-sans text-sm not-italic leading-[20px] font-normal mb-2"
                    >
                      About Us
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://remoterecruit.com/remote-jobs/contact/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white font-sans text-sm not-italic leading-[20px] font-normal mb-2"
                    >
                      Contact Us
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://remoterecruit.com/remote-jobs/blog/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white font-sans text-sm not-italic leading-[20px] font-normal mb-2"
                    >
                      Remote Jobs Blog
                    </a>
                  </li>
                </ul>
              </div>
              <div>
                <p className="text-white font-sans text-base not-italic leading-[20px] font-bold mb-5">
                  Site Policy
                </p>
                <ul>
                  <li>
                    <a
                      href="https://remoterecruit.com/remote-jobs/terms/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white font-sans text-sm not-italic leading-[20px] font-normal mb-2"
                    >
                      Disclaimer
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://remoterecruit.com/privacy-policy"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white font-sans text-sm not-italic leading-[20px] font-normal mb-2"
                    >
                      Privacy Policy
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://remoterecruit.com/terms-of-service"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white font-sans text-sm not-italic leading-[20px] font-normal mb-2"
                    >
                      Terms and Conditions
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://remoterecruit.com/accessbility-statement"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white font-sans text-sm not-italic leading-[20px] font-normal mb-2"
                    >
                      Accessbility Statement
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://remoterecruit.com/sms-terms"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white font-sans text-sm not-italic leading-[20px] font-normal mb-2"
                    >
                      SMS Terms
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="w-[320.708px] md:w-[680px] lg:w-[1180px] border-t border-[#FFF] mx-auto mt-[50px] mb-[22px] opacity-25 "></div>

        <div className="flex flex-col lg:flex-row items-center justify-between">
          <div className="hidden lg:block">
            <p className="text-white font-sans text-sm not-italic leading-[14px] font-normal mt-2 mb-5 lg:mb-0">
              © {new Date().getFullYear()} Remote Recruit. All Rights Reserved.
            </p>
          </div>
          <div className="flex items-center gap-[36px]">
            <ul className="space-y-4">
              <li className="flex space-x-4">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.facebook.com/RRremoterecruitofficial/"
                  aria-label="Visit Remote Recruit on Facebook"
                  className="hover:rotate-45 transition-transform duration-300 w-[39px] h-[39px] flex justify-center items-center social-icons rounded-full cursor-pointer"
                >
                  <FacebookIcon aria-hidden="true" />
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.instagram.com/remoterecruit/"
                  aria-label="Visit Remote Recruit on Instagram"
                  className="hover:rotate-45 transition-transform duration-300 w-[39px] h-[39px] flex justify-center items-center social-icons rounded-full cursor-pointer"
                >
                  <InstagramIcon aria-hidden="true" />
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://x.com/remoterecruit01"
                  aria-label="Visit Remote Recruit on X (formerly Twitter)"
                  className="hover:rotate-45 transition-transform duration-300 w-[39px] h-[39px] flex justify-center items-center social-icons rounded-full cursor-pointer"
                >
                  <TwitterIcon2 aria-hidden="true" />
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.tiktok.com/@remoterecruite"
                  aria-label="Visit Remote Recruit on TikTok"
                  className="hover:rotate-45 transition-transform duration-300 w-[39px] h-[39px] flex justify-center items-center social-icons rounded-full cursor-pointer"
                >
                  <TiktokIcon aria-hidden="true" />
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.youtube.com/channel/UCBEwwmwrEa9lNWukkTXvHRw"
                  aria-label="Visit Remote Recruit on YouTube"
                  className="hover:rotate-45 transition-transform duration-300 w-[39px] h-[39px] flex justify-center items-center social-icons rounded-full cursor-pointer"
                >
                  <YoutubeIcon aria-hidden="true" />
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.linkedin.com/company/remoterecruit-com-official/about/"
                  aria-label="Visit Remote Recruit on LinkedIn"
                  className="hover:rotate-45 transition-transform duration-300 w-[39px] h-[39px] flex justify-center items-center social-icons rounded-full cursor-pointer"
                >
                  <LinkedinIcon aria-hidden="true" />
                </a>
              </li>
            </ul>
          </div>
          <div className="block lg:hidden mt-10">
            <p className="text-white font-sans text-sm not-italic leading-[14px] font-normal mt-2 mb-5 lg:mb-0">
              © {new Date().getFullYear()} Remote Recruit. All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
